var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EditContainer',{attrs:{"section":_vm.$store.getters['cvSectionProfile/cvSectionProfile']}})}
var staticRenderFns = []

export { render, staticRenderFns }